import { partAnswerKey } from "./assessmentKeys";

/** True when every required part of the question has a valid answer. */
export function isQuestionAnswered(question, answers) {
  const qtype = (question?.type || "mcq").toLowerCase();
  const partType = (question?.parts?.[0]?.type || "").toLowerCase();
  const isRating = qtype === "rating" || partType === "rating";

  for (const p of question?.parts || []) {
    const key = partAnswerKey(question, p);
    const val = answers[key] ?? p.answer ?? "";

    if (isRating) {
      if ((p.type || "").toLowerCase() !== "rating" && p !== question.parts?.[0]) continue;
      if (!val || !String(val).trim()) return false;
      continue;
    }

    if (qtype === "mcq" || !question.type) {
      if (p.type !== "importance" && p.type !== "agreement") continue;
      if (!val || !String(val).trim()) return false;
      continue;
    }

    if (qtype === "text") {
      const part = question.parts?.[0] || { type: "text" };
      const ak = partAnswerKey(question, part);
      const v = answers[ak] ?? part.answer ?? "";
      const s = String(v).trim();
      if (!s || (s.length < 2 && s.toUpperCase() !== "NA")) return false;
      continue;
    }

    if (qtype === "dropdown") {
      if (!val || !String(val).trim()) return false;
    }

    if (qtype === "multi") {
      if (!val || !String(val).trim()) return false;
    }
  }
  return (question?.parts || []).length > 0;
}

/** Last fully answered question id in display order, or null. */
export function findLastAnsweredQuestionId(questionsInOrder, answers) {
  let lastId = null;
  for (const q of questionsInOrder || []) {
    if (q?.id == null) continue;
    if (isQuestionAnswered(q, answers)) {
      lastId = String(q.id);
    }
  }
  return lastId;
}

/** First question in order that still needs answers, or null. */
export function findFirstUnansweredQuestionId(questionsInOrder, answers) {
  for (const q of questionsInOrder || []) {
    if (q?.id == null) continue;
    if (!isQuestionAnswered(q, answers)) return String(q.id);
  }
  return null;
}
